import {Component, Input, OnInit} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {User} from '../../../../core/entities/user/user.entity';
import {CreatorDashboardService} from '../../../services/creator/creator-dashboard.service';
import {DashboardOnboarding} from '../../../entities/dashboard/onboarding.entity';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'app-onboarding-banner',
  imports: [
    TranslocoPipe,
    RouterLink,
    NgClass
  ],
  templateUrl: './onboarding-banner.component.html',
  standalone: true,
  styleUrl: './onboarding-banner.component.scss'
})
export class OnboardingBannerComponent implements OnInit {
  @Input() photographer: User|null = null;
  public onboarding: DashboardOnboarding|null = null;

  readonly radius = 20;
  readonly circumference = 2 * Math.PI * this.radius;

  public constructor(
    private readonly dashboardService: CreatorDashboardService,
  ) {
  }

  public ngOnInit(): void {
    this.dashboardService.getOnboarding().subscribe((onboarding: DashboardOnboarding) => {
      this.onboarding = onboarding;
    });
  }

  public isFinishedOnboarding(): boolean
  {
    return this.onboarding !== null
      && this.onboarding.publicProfile
      && this.onboarding.services
      && this.onboarding.shared
  }

  public getStrokeOffset(progress: number): number {
    const offset = this.circumference - (progress / 100) * this.circumference;
    return offset;
  }

}
